export const paths = {
  contact: "/contact",
  contactMessages: "/contact-messages",
  contactMessage: "/contact-messages/:contactMessage",
};
